<template>
  <LoginScreen v-if="!isAuthenticated" @authenticated="handleAuth" />
  <router-view v-else />
</template>

<script setup>
import { ref, onMounted, provide } from 'vue';
import LoginScreen from './components/LoginScreen.vue';

const isAuthenticated = ref(false);

const checkAuth = () => {
  const token = localStorage.getItem('token_precios');
  if (!token) {
    isAuthenticated.value = false;
    return;
  }
  // Verificar que el token NO esté expirado
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const exp = payload.exp;
    if (exp && Date.now() >= exp * 1000) {
      // Token expirado: limpiar y forzar login
      localStorage.removeItem('token_precios');
      isAuthenticated.value = false;
      return;
    }
    isAuthenticated.value = true;
  } catch {
    localStorage.removeItem('token_precios');
    isAuthenticated.value = false;
  }
};

const handleAuth = () => {
  isAuthenticated.value = true;
};

// Función global para que cualquier vista pueda forzar logout (al detectar 401)
const forceLogout = () => {
  localStorage.removeItem('token_precios');
  isAuthenticated.value = false;
};

provide('forceLogout', forceLogout);

onMounted(() => {
  checkAuth();
  // Re-verificar token cada minuto
  setInterval(checkAuth, 60_000);
});
</script>